"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_json_view_1 = tslib_1.__importDefault(require("react-json-view"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const svg_1 = require("../../../../svg");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../../graphql");
const util_1 = require("util");
class EspRequestPlayground extends react_1.default.Component {
    getInspector(data) {
        return (react_1.default.createElement("div", { className: "w-100 border rounded p-2 bg-white text-left", style: { height: 450, overflowY: 'auto' }, "data-cy": "inspector" },
            data ? (react_1.default.createElement(react_json_view_1.default, { collapseStringsAfterLength: 200, src: data })) : (react_1.default.createElement("span", { className: "text-monospace" },
                '<--',
                " Click to test")),
            react_1.default.createElement("div", { "data-cy": "inspector-raw-data", className: "d-none" }, util_1.inspect(data, false, 100))));
    }
    getRequestSection(name, query, variables) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_components_1.Mutation, { mutation: query, variables: variables || {
                    data: {
                        espId: this.props.integration.id,
                        fromEmail: 'charley@yellowbrim.com',
                        fromName: 'Test Name',
                        html: 'Test HTML',
                        listId: this.props.integration.integrationType === 'Mailchimp'
                            ? '40705eb3be'
                            : '234D351A-B2DD-42D1-A408-5341A7EE935C',
                        replyToEmail: 'charley@yellowbrim.com',
                        subjectLines: ['Test subject line'],
                    },
                } }, (mutate, result) => {
                return (react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center mb-2", "data-cy": "esp-request-playground-section", "data-cy-name": `esp-request-playground-section:${name}` },
                    react_1.default.createElement(reactstrap_1.Col, { md: "5", className: "text-center" },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(reusables_1.AjaxButton, { success: !!result.data, loading: result.loading, error: result.error, label: name, icon: pro_solid_svg_icons_1.faDownload, onClick: mutate, size: "lg", className: "w-100" }),
                            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Integration", action: "read", 
                                // marginTop
                                apolloError: result.error }))),
                    react_1.default.createElement(reactstrap_1.Col, { md: "5" }, this.getInspector(result.data))));
            })));
    }
    render() {
        const { integration } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center" },
                react_1.default.createElement(reactstrap_1.Col, { md: "10" },
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("h2", null, "ESP request playground"),
                    react_1.default.createElement("p", null,
                        "Test some basic network requests to the ",
                        integration.displayType,
                        ' ',
                        "API"),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("br", null))),
            react_1.default.createElement("br", null),
            react_1.default.createElement("h4", { className: "text-center my-4" },
                react_1.default.createElement(react_2.OsmosysLogo, null),
                " Generic Osmosys methods"),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            this.getRequestSection('espSendCampaign', graphql_1.espSendCampaign),
            this.getRequestSection('espCreateCampaign', graphql_1.espCreateCampaign),
            this.getRequestSection('espSendCampaignTest', graphql_1.espSendCampaignTest),
            integration.integrationType === 'Salesforce' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h4", { className: "text-center my-4" },
                    react_1.default.createElement(svg_1.SalesforceLogo, { height: "1em", width: "2em" }),
                    " Salesforce-speific methods"),
                this.getRequestSection('createEmailSendDefinition', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'createEmailSendDefinition',
                }),
                this.getRequestSection('getUserInfo', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'getUserInfo',
                }),
                this.getRequestSection('listAssets', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'listAssets',
                }),
                this.getRequestSection('createEmail', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'createEmail',
                }),
                this.getRequestSection('getSenderProfiles', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'getSenderProfiles',
                }),
                this.getRequestSection('getSendClassifications', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'getSendClassifications',
                }),
                this.getRequestSection('sfmcGetCampaignCollection', graphql_1.sfmcRequest, {
                    id: this.props.integration.id,
                    requestType: 'sfmcGetCampaignCollection',
                })))));
    }
}
exports.EspRequestPlayground = EspRequestPlayground;
//# sourceMappingURL=index.js.map